import * as React from "react";
import { commonState } from "../../../store";
import { DriverShiftsView } from "./DriverShiftsView";
import { DetailReportState } from "./store";
import { WeeklyReportState } from "../store";
import Checkbox from "@mui/material/Checkbox";
import * as service from "../../../services/weekly/weeklyreport";
import { weekYearToMonSun, YMD_FORMAT } from "../../../utils/time";
import Button from "@mui/material/Button";
import { Box, ThemeProvider, createTheme } from "@mui/system";
import { colors, fontSizes } from "../../../theme";
import { HermesSnackbar } from "../../../components/snackbar";
import { getSessionCookie } from "../../../components/cookies";

interface Props {
    common: commonState;
    weeklyreport: WeeklyReportState;
    weeklydetail: DetailReportState;
}
export interface DayShift {
    item?: string;
}

export const CurrentDriverHeaderView: React.FC<Props> = (props: Props) => {
    let checked = false;
    if (props.weeklydetail && props.weeklydetail.detailHeaderInfo) {
        checked = props.weeklydetail.detailHeaderInfo.feedback_flag;
    }

    let datesString = "";
    if (props.weeklydetail.detailHeaderInfo) {
        const { mon, sun } = weekYearToMonSun(
            props.weeklydetail.detailHeaderInfo.week_no,
            props.weeklydetail.detailHeaderInfo.year,
            YMD_FORMAT
        );
        datesString = `(${mon}~${sun})`;
    }

    const label = { inputProps: { "aria-label": "声かけ" } };

    return (
        <Box
            id="CurrentDriverHeaderView"
            sx={{
                p: 8,
                backgroundColor: colors.white.main,
                display: "flex",
                flexDirection: "row",
                alignItems: "end",
                width: "100%",
                zIndex: 3000,
                position: "absolute",
                boxShadow: "0px 3px 12px rgba(0, 0, 0, 0.2)",
            }}
        >
            <Box>
                <Box sx={{ fontSize: fontSizes.large, fontWeight: "bold" }}>
                    {props.weeklydetail.selectedDriver?.driver_code}
                </Box>
                <Box
                    sx={{
                        fontSize: fontSizes.xxlarge,
                        fontWeight: "bold",
                        width: "max-content",
                    }}
                >
                    {props.weeklydetail.selectedDriver?.driver_name}
                </Box>
            </Box>
            <Box sx={{ p: 2, fontSize: fontSizes.large, fontWeight: "bold" }}>
                {datesString}
            </Box>
            <Box
                id="Right-buttons-holder"
                sx={{
                    textAlign: "end",
                    width: "95%",
                    display: "flex",
                    justifyContent: "end",
                    fontSize: fontSizes.normal,
                    alignItems: "baseline",
                }}
            >
                <Box
                    sx={{
                        p: 4,
                        pb: 0,
                    }}
                >
                    <label style={{ color: colors.black.main }}>
                        <Checkbox
                            checked={checked}
                            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                            {...label}
                            onClick={(x: any) => {
                                service.driverCellSnackbarAction(!checked);
                                service.setKoeKakeFlag(!checked);
                                service.setNeedUpdateFlag(true);
                            }}
                        />
                        声かけ
                    </label>
                </Box>
                <Box sx={{ displayPrint: "none" }}>
                    <Button
                        variant="contained"
                        onClick={(x) => {
                            window.print();
                        }}
                        color="primary"
                        size="medium"
                    >
                        印刷
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export const WeeklyDetailScreenContainer: React.FC<Props> = (props: Props) => {
    return (
        <Box sx={{ justifyContent: "center", width: "95%", m: 12 }}>
            <Box id="current-driver-wrapper" sx={{ mb: 3 }}>
                <CurrentDriverHeaderView {...props} />
            </Box>
            <DriverShiftsView
                weeklydetail={props.weeklydetail}
                permissions={getSessionCookie().consoleUserPermissions}
            />
            <HermesSnackbar
                open={props.common.snackbarToggled}
                msg={props.common.snackbarMsg}
            />
        </Box>
    );
};
